import { render, staticRenderFns } from "./userNotification.vue?vue&type=template&id=4e7da580"
import script from "./userNotification.vue?vue&type=script&lang=js"
export * from "./userNotification.vue?vue&type=script&lang=js"
import style0 from "./userNotification.vue?vue&type=style&index=0&id=4e7da580&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports